<template>
  <div>
    <el-row id="opCoderRow" v-show="grouping === '1'">
      <el-col :span="24">
        <div id="opCoderChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="opCoderTrendingRow" v-show="grouping === '15'">
      <el-col :span="24">
        <div id="opCoderTrendingChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="opApcRow" v-show="grouping === '2'">
      <el-col :span="24">
        <div id="opApcChart" v-show="!noReviewDashboardData" style=" margin: 0 auto"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="opPatTypeRow" v-show="grouping === '3'">
      <el-col :span="24">
        <div id="opPatTypeChart" v-show="!noReviewDashboardData" style=" margin: 0 auto; height: 100%;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="opFacilityRow" v-show="grouping === '5'">
      <el-col :span="24">
        <div id="opFacilityChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="opProjectRow" v-show="grouping === '17'">
      <el-col :span="24">
        <div id="opProjectChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="opReasonRow" v-show="grouping === '6'">
      <el-col :span="24">
        <div id="opReasonChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="opHeaderReasonRow" v-show="grouping === '7'">
      <el-col :span="24">
        <div id="opHeaderReasonChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="opDxRow" v-show="grouping === '8'">
      <el-col :span="24">
        <div id="opDxChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="opSdohRow" v-show="grouping === '14' || grouping === '18'">
      <el-col :span="24">
        <div id="opSdohChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="opHCCRow" v-show="grouping === '12'">
      <el-col :span="24">
        <div id="opHCCChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="opHCCV28Row" v-show="grouping === '13'">
      <el-col :span="24">
        <div id="opHCCV28Chart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="opCptRow" v-show="grouping === '9'">
      <el-col :span="24">
        <div id="opCptChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="opModRow" v-show="grouping === '10'">
      <el-col :span="24">
        <div id="opModChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="opPxRow" v-show="grouping === '11'">
      <el-col :span="24">
        <div id="opPxChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="opServiceLineRow" v-show="grouping === '16'">
      <el-col :span="24">
        <div id="opServiceLineChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
  </div>
</template>

<script>
import HiaAuthorization from '@/mixins/hiaAuthorization'
import money from '@/mixins/money'
import { mapState, mapActions } from 'vuex'
import hiaFilters from '@/mixins/hiaFilters'
import debounce from 'debounce'

export default {
  data: function() {
    return {
      highCharts: null,
      noReviewDashboardData: true,
      visibleSeries: []
    }
  },
  name: 'OutpatientCharts',
  mixins: [HiaAuthorization, money, hiaFilters],
  props: {
    grouping: { type: String },
    filterCriteria: { type: String },
    codeTypeGrouping: { type: Array },
    isClosed: { type: Boolean },
    selectedGrouping: { type: Array }
  },
  components: {},
  methods: {
    ...mapActions('dashboard/', ['GET_DASHBOARD_PROJECTS']),
    moneyFormatter(value) {
      return `$${this.formatMoney(value)}`
    },
    getTableData(grouping) {
      // let opIndex = this.reviewDashboardData.findIndex(x => x.type === 'outpatient') > -1 ? this.reviewDashboardData.findIndex(x => x.type === 'outpatient') : null
      // if (opIndex !== null) {
      //   let groupIndex = this.reviewDashboardData[opIndex].largeStats.findIndex(x => x.title === grouping)
      //   return this.reviewDashboardData[opIndex].largeStats.some(x => x.title === grouping) ? this.reviewDashboardData[opIndex].largeStats[groupIndex].data : []
      // }
      // return []
      if (!this.reviewDashboardData) {
        return []
      }

      let opIndex = this.reviewDashboardData.findIndex(x => x.type === 'outpatient') > -1 ? this.reviewDashboardData.findIndex(x => x.type === 'outpatient') : null
      if (opIndex !== null && this.reviewDashboardData[opIndex].largeStats) {
        let groupIndex = this.reviewDashboardData[opIndex].largeStats.findIndex(x => x.title === grouping)
        let data = this.reviewDashboardData[opIndex].largeStats.some(x => x.title === grouping) ? this.reviewDashboardData[opIndex].largeStats[groupIndex].data : []
        if (this.codeTypeGrouping.length) {
          data = data.filter(x => {
            let val
            this.codeTypeGrouping.forEach(y => {
              if (x.codeDesc === y) {
                val = x
              }
            })
            return val
          })
        }

        if (this.selectedGrouping.length) {
          let groupKey = this.reviewDashboardData[opIndex].largeStats.some(x => x.title === grouping) ? this.reviewDashboardData[opIndex].largeStats[groupIndex].groupKey : ''
          data = data.filter(x => {
            let val
            this.selectedGrouping.forEach(y => {
              if (x[groupKey].toString() === y.toString()) {
                val = x
              }
            })
            return val
          })
        }

        return data
      }
      return []
    },
    getSeriesData(data, category, divId) {
      let seriesData = []

      if (category === 'description') {
        seriesData.push({ name: 'Total Records', data: data.map(x => x.number) })
        return seriesData
      }

      if (category === 'changeDesc') {
        seriesData.push({ name: 'Total Records', data: data.map(x => x.numRecords) })
        return seriesData
      }

      if (category === 'apc') {
        seriesData.push({ name: 'Total APCs', data: data.map(x => parseFloat((x.apcCodes * 100).toFixed(2))) })
        return seriesData
      }

      if (category === 'code') {
        if (['opDxChart', 'opSdohChart'].includes(divId)) {
          seriesData.push({ name: 'Accuracy Rate', data: data.map(x => parseFloat((x.cmCodes * 100).toFixed(2))) })
          return seriesData
        }

        if (['opHCCChart'].includes(divId)) {
          seriesData.push({ name: 'Accuracy Rate', data: data.map(x => parseFloat((x.accuracyRate * 100).toFixed(2))) })
          return seriesData
        }

        if (['opHCCV28Chart'].includes(divId)) {
          seriesData.push({ name: 'Accuracy Rate', data: data.map(x => parseFloat((x.accuracyRate * 100).toFixed(2))) })
          return seriesData
        }

        if (['opCptChart'].includes(divId)) {
          seriesData.push({ name: 'Accuracy Rate', data: data.map(x => parseFloat((x.cptCodes * 100).toFixed(2))) })
          return seriesData
        }

        if (['opPxChart'].includes(divId)) {
          seriesData.push({ name: 'Accuracy Rate', data: data.map(x => parseFloat((x.pcsCodes * 100).toFixed(2))) })
          return seriesData
        }

        if (['opModChart'].includes(divId)) {
          seriesData.push({ name: 'Accuracy Rate', data: data.map(x => parseFloat((x.modCodes * 100).toFixed(2))) })
          return seriesData
        }
      }

      // seriesData.push({ name: 'Total Records', data: data.filter(x => x.totalRecords).map(x => parseFloat(x.totalRecords)) })
      // seriesData.push({ name: 'Reimbursement Diff', data: data.map(x => parseFloat(x.reimbDiff)) })
      seriesData.push({ name: 'Total APCs', data: data.map(x => parseFloat((x.apcCodes * 100).toFixed(2))), visible: false })
      seriesData.push({ name: 'Total Codes', data: data.map(x => parseFloat((x.totalCodes * 100).toFixed(2))) })
      seriesData.push({ name: 'CM Codes', data: data.map(x => parseFloat((x.cmCodes * 100).toFixed(2))), visible: false })
      seriesData.push({ name: 'PCS Codes', data: data.map(x => parseFloat((x.pcsCodes * 100).toFixed(2))), visible: false })
      seriesData.push({ name: 'MOD Codes', data: data.map(x => parseFloat((x.modCodes * 100).toFixed(2))), visible: false })
      seriesData.push({ name: 'E/M Codes', data: data.map(x => parseFloat((x.emCodes * 100).toFixed(2))), visible: false })
      seriesData.push({ name: 'I&I Codes', data: data.map(x => parseFloat((x.iiCodes * 100).toFixed(2))), visible: false })
      seriesData.push({ name: 'S&I Codes', data: data.map(x => parseFloat((x.siCodes * 100).toFixed(2))), visible: false })
      return seriesData
    },
    buildBarChart(data, category, divId) {
      let vm = this
      let seriesData = this.getSeriesData(data, category, divId)
      let categoryData = []
      let floor = 50
      let ceiling = 100
      categoryData = data.map(x => (Number.isInteger(x[category]) ? x[category] : x[category].replace(/>/g, '').replace(/</g, '')))

      if (divId === 'opCoderTrendingChart') {
        categoryData = data.map(x => (Number.isInteger(x[category]) ? `${x[category]} <br/> ${x.projectName}` : `${x[category].replace(/>/g, '').replace(/</g, '')} <br/> ${x.projectName}`))
      }

      if (category === 'description' || category === 'changeDesc') {
        floor = 0
        if (seriesData.length > 0 && seriesData[0].data.length > 0) {
          ceiling = seriesData[0].data.reduce((t, a) => t + a)
        }
      }

      // show visible series if exist
      if (this.visibleSeries.length) {
        seriesData.forEach((v, i) => {
          if (this.visibleSeries.some(x => x.name === v.name)) {
            v.visible = true
          }
        })
      }

      // seriesData.push({ name: 'cmCodes', data: [1.1, 2, 3.54, 4, 5, 6, 7, 6, 4, 3, 3] })
      this.highCharts.chart(divId, {
        chart: {
          type: 'bar',
          height: '50%',
          events: {
            render: function() {
              vm.visibleSeries = this.series.filter(x => x.visible)
            }
          }
        },
        accessibility: {
          // description: 'An area chart compares the nuclear stockpiles of the USA and the USSR/Russia between 1945 and 2017. The number of nuclear weapons is plotted on the Y-axis and the years on the X-axis. The chart is interactive, and the year-on-year stockpile levels can be traced for each country. The US has a stockpile of 6 nuclear weapons at the dawn of the nuclear age in 1945. This number has gradually increased to 369 by 1950 when the USSR enters the arms race with 6 weapons. At this point, the US starts to rapidly build its stockpile culminating in 32,040 warheads by 1966 compared to the USSR’s 7,089. From this peak in 1966, the US stockpile gradually decreases as the USSR’s stockpile expands. By 1978 the USSR has closed the nuclear gap at 25,393. The USSR stockpile continues to grow until it reaches a peak of 45,000 in 1986 compared to the US arsenal of 24,401. From 1986, the nuclear stockpiles of both countries start to fall. By 2000, the numbers have fallen to 10,577 and 21,000 for the US and Russia, respectively. The decreases continue until 2017 at which point the US holds 4,018 weapons compared to Russia’s 4,500.'
        },
        title: {
          // text: ''
          style: { display: 'none' }
        },
        subtitle: {
          // text: 'Sources: <a href="https://thebulletin.org/2006/july/global-nuclear-stockpiles-1945-2006">' +
          //   'thebulletin.org</a> &amp <a href="https://www.armscontrol.org/factsheets/Nuclearweaponswhohaswhat">' +
          //   'armscontrol.org</a>'
        },
        legend: {
          reversed: false,
          verticalAlign: 'top'
        },
        xAxis: {
          reserveSpace: false,
          allowDecimals: true,
          categories: categoryData,
          labels: {
            formatter: function(i) {
              // console.log(i)
              // return (i.pos + 1)
              return this.value
            }
          }
        },
        yAxis: {
          title: {
            text: ''
          },
          ceiling: ceiling,
          floor: floor,
          labels: {
            formatter: function(i) {
              return category === 'description' || category === 'changeDesc' ? `${this.value}` : `${this.value}%`
            }
          }
        },
        tooltip: {
          pointFormat: category === 'description' || category === 'changeDesc' ? '{point.y}' : '{point.y}%'
        },
        plotOptions: {
          series: {
            // stacking: 'normal'
          }
        },
        series: seriesData,
        colors: ['#88B95B', '#005695', '#FFC40C', '#6DCFF6', '#EC008C', '#808285', '#58595b', '#005695', '#004776', '#EC008C', '#6DCFF6', '#EC008C', '#6DCFF6', '#FFC40C', '#88B95B', '#808285', '#58595b', '#005695', '#004776', '#EC008C', '#6DCFF6', '#EC008C', '#6DCFF6', '#FFC40C', '#88B95B', '#808285', '#58595b', '#005695', '#004776', '#EC008C', '#6DCFF6']
      })
    },
    loadChart() {
      switch (this.grouping) {
        case '1':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.coderTableData, this.filterCriteria) : this.coderTableData, 'coder', 'opCoderChart')
          break
        case '15':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.coderTrendingTableData, this.filterCriteria) : this.coderTrendingTableData, 'coder', 'opCoderTrendingChart')
          break
        case '2':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.apcTableData, this.filterCriteria) : this.apcTableData, 'apc', 'opApcChart')
          break
        case '3':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.patientTypeTableData, this.filterCriteria) : this.patientTypeTableData, 'patTypeDesc', 'opPatTypeChart')
          break
        case '5':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.facilityTableData, this.filterCriteria) : this.facilityTableData, 'cliName', 'opFacilityChart')
          break
        case '17':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.projectTableData, this.filterCriteria) : this.projectTableData, 'projectName', 'opProjectChart')
          break
        case '6':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.reasonTableData, this.filterCriteria) : this.reasonTableData, 'description', 'opReasonChart')
          break
        case '7':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.headerReasonTableData, this.filterCriteria) : this.headerReasonTableData, 'changeDesc', 'opHeaderReasonChart')
          break
        case '8':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.dxTableData, this.filterCriteria) : this.dxTableData, 'code', 'opDxChart')
          break
        case '14':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.sdohTableData, this.filterCriteria) : this.sdohTableData, 'code', 'opSdohChart')
          break
        case '18':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.sdohTableData, this.filterCriteria) : this.sdohTableData, 'code', 'opSdohChart')
          break
        case '12':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.hccTableData, this.filterCriteria) : this.hccTableData, 'code', 'opHCCChart')
          break
        case '13':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.hccV28TableData, this.filterCriteria) : this.hccV28TableData, 'code', 'opHCCV28Chart')
          break
        case '9':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.cptTableData, this.filterCriteria) : this.cptTableData, 'code', 'opCptChart')
          break
        case '10':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.modTableData, this.filterCriteria) : this.modTableData, 'code', 'opModChart')
          break
        case '11':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.pxTableData, this.filterCriteria) : this.pxTableData, 'code', 'opPxChart')
          break
        case '16':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.serviceLineTableData, this.filterCriteria) : this.serviceLineTableData, 'clientServiceLineName', 'opServiceLineChart')
          break
      }
    }
  },
  created: function() {},
  mounted: function() {
    import(/* webpackChunkName: "highcharts" */ 'highcharts').then(({ default: hc }) => {
      this.highCharts = hc
    })
  },
  computed: {
    ...mapState('user/', ['currentClient', 'currentClientId']),
    ...mapState('dashboard/', ['dashboardData', 'dashboardProjects', 'reviewDashboardData']),
    coderTableData() {
      return this.getTableData('By Coder')
    },
    coderTrendingTableData() {
      return this.getTableData('By Coder Trending')
    },
    patientTypeTableData() {
      return this.getTableData('By Patient Type')
    },
    apcTableData() {
      return this.getTableData('By APC')
    },
    facilityTableData() {
      return this.getTableData('By Facility')
    },
    projectTableData() {
      return this.getTableData('By Project')
    },
    reasonTableData() {
      return this.getTableData('By Reason')
    },
    headerReasonTableData() {
      return this.getTableData('By Header Reason')
    },
    dxTableData() {
      return this.getTableData('By Dx')
    },
    sdohTableData() {
      return this.getTableData(this.grouping === '18' ? 'By Pri Dx' : 'By SDOH Dx')
    },
    hccTableData() {
      return this.getTableData('By HCC')
    },
    hccV28TableData() {
      return this.getTableData('By HCC V28')
    },
    cptTableData() {
      return this.getTableData('By CPT')
    },
    modTableData() {
      return this.getTableData('By MOD')
    },
    pxTableData() {
      return this.getTableData('By PCS')
    },
    serviceLineTableData() {
      return this.getTableData('By Service Line')
    }
  },
  watch: {
    reviewDashboardData: {
      handler: function() {
        let opIndex = this.reviewDashboardData.findIndex(x => x.type === 'outpatient') > -1 ? this.reviewDashboardData.findIndex(x => x.type === 'outpatient') : null
        if (opIndex !== null) {
          if (this.reviewDashboardData[opIndex].largeStats && this.reviewDashboardData[opIndex].largeStats.length) {
            this.noReviewDashboardData = false
            this.loadChart()
          } else {
            this.noReviewDashboardData = true
          }
        } else {
          this.noReviewDashboardData = true
        }
      },
      deep: true
    },
    grouping() {
      this.visibleSeries = []
      this.loadChart()
    },
    codeTypeGrouping() {
      this.loadChart()
    },
    selectedGrouping() {
      this.loadChart()
    },
    filterCriteria: debounce(function() {
      this.loadChart()
    }, 350),
    isClosed() {
      setTimeout(() => {
        this.loadChart()
      }, 200)
    }
  }
}
</script>
